import React from "react"
import DropDownSelector from "../../components/DropDownSelector"
import { SortMethodValue } from "../../utils/sort"

type SortDropdownProps = {
  sort: string
  setSort: (sort: string) => void
}

export default function SortDropdown({ sort, setSort }: SortDropdownProps) {
  return (
    <DropDownSelector
      title="Sort by"
      dropDownType="single"
      onOptionSelected={(name: SortMethodValue) => setSort(name)}
      menuListProps={{
        zIndex: 2,
      }}
      options={
        [
          {
            title: "Relevance",
            name: "BY_RELEVANCE",
            selected: sort === "BY_RELEVANCE",
          },
          {
            title: "Price (Low - High)",
            name: "BY_PRICE_LOW",
            selected: sort === "BY_PRICE_LOW",
          },
          {
            title: "Price (High - Low)",
            name: "BY_PRICE_HIGH",
            selected: sort === "BY_PRICE_HIGH",
          },
          {
            title: "A-Z",
            name: "BY_A_Z",
            selected: sort === "BY_A_Z",
          },
          {
            title: "Z-A",
            name: "BY_Z_A",
            selected: sort === "BY_Z_A",
          },
        ] as {
          title: string
          name: SortMethodValue
          selected: boolean
        }[]
      }
      showChevron
    />
  )
}
